import React from "react";
import { ModalBuilder, Lookup } from "@redriver/cinnamon";
import { PermissionCheck } from "features/../../../shared/components/auth";
import { Targets, Actions } from "constants/permissions";
import { IconButton } from "features/../../../shared/components/buttons";
import Add from "features/../../../shared/assets/white-add.svg";
import { LookupTypes } from "features/../../../shared/features/Settings";
import ServiceForm from "./ServiceForm";
import { TranslatedModal } from "../../../components/modals";

const AddServiceModal = ({ submitAction, onSubmitted, dealerOfficeId }) => (
  <PermissionCheck target={Targets.Service} action={Actions.Create}>
    <Lookup
      lookup={LookupTypes.ContractTypes}
      render={({ loading, response: contractTypeResponse }) => (
        <ModalBuilder
          withForm
          submitAction={submitAction}
          submitParams={{ dealerOfficeId }}
          onSubmitted={onSubmitted}
          renderTrigger={showModal => (
            <IconButton
              icon={Add}
              primary
              content="New Service"
              onClick={showModal}
            />
          )}
          renderModal={(modalProps, formProps) => (
            <TranslatedModal.Add
              {...modalProps}
              loading={loading}
              size="small"
              header="Add Quarterly Service"
              submitLabel="Create Quarterly Service"
            >
              <ServiceForm
                formProps={formProps}
                contractTypeResponse={contractTypeResponse}
              />
            </TranslatedModal.Add>
          )}
        />
      )}
    />
  </PermissionCheck>
);

export default AddServiceModal;
